//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React, { useState } from 'react';

import { InstagramUserEmbed } from '@components/atoms/instagram-embed/InstagramUserEmbed';
import Popover from '@components/molecules/popover/Popover';
import { INSTAGRAM_USER_IFRAME_SHOW_DELAY } from '@universal-scheduling/components/scheduler/post-details-forms/instagram/InstagramPostDetailsConstants';

interface Props {
  children: React.ReactNode;
  isDisabled?: boolean;
  username: string;
}

export const InstagramMentionIFramePopover = ({
  children,
  isDisabled = false,
  username,
}: Props) => {
  const [hasLoaded, setHasLoaded] = useState(false);

  return (
    <Popover
      appendTarget={'body'}
      content={
        <InstagramUserEmbed
          hasLoaded={hasLoaded}
          setHasLoaded={setHasLoaded}
          username={username}
        />
      }
      onTogglePopover={(isOpen: boolean) => {
        if (!isOpen) {
          setHasLoaded(false);
        }
      }}
      delay={{ showDelay: INSTAGRAM_USER_IFRAME_SHOW_DELAY }}
      isDisabled={isDisabled}
      placement='top'
      shouldShowArrow={true}
      target={<>{children}</>}
    />
  );
};
